"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function cleanImportUrlFactory() {
  return function (url) {
    var importUrl = url.split(" from ").pop();
    return importUrl.trim();
  };
}

exports.cleanImportUrlFactory = cleanImportUrlFactory;